import { render, staticRenderFns } from "./DetailedPostCost.vue?vue&type=template&id=37651348&"
import script from "./DetailedPostCost.vue?vue&type=script&lang=js&"
export * from "./DetailedPostCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports